import {PIXI} from '@colonist/pixi'
import {RoundedBgView} from './RoundedBgView'
import {SectionView} from './SectionView'
import {Sprites} from '../ui_game/UIGameImageDictionary'
import {UIGameSpriteHandler} from '../UIGameSpriteHandler'

export interface Position {
    x: number
    y: number
    w: number
    h: number
}

export class SectionBgView extends SectionView {
    roundedBg: RoundedBgView
    readonly initialPosition: Position

    constructor(x: number, y: number, w: number, h: number, container: PIXI.Container, removePadding: boolean = false) {
        super(x, y, w, h, container, removePadding)
        this.initialPosition = {x: this.x, y: this.y, w: this.width, h: this.height}
    }

    drawBg(color: number = 0x000000, alpha: number = 0.8, outlineThickness: number = 0, outlineColor: number = 0xFFFFFF, outlineAlpha: number = 1, borderRadius: number = 5) {
        this.removeRoundedBg()
        const newBg = new PIXI.Graphics()
        if(outlineThickness != 0) newBg.lineStyle(outlineThickness, outlineColor, outlineAlpha)
        newBg.beginFill(color, alpha)
        newBg.drawRoundedRect(0, 0, this.initialPosition.w, this.initialPosition.h, borderRadius)
        newBg.endFill()
        this.addChild(newBg)
        this.replaceOldBg(newBg)
        this.bg.zIndex = -1
        this.sortChildren()
    }

    drawRoundedBg(texture: PIXI.Texture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.bg_section), useInitialPosition: boolean = false, radius?: number) {
        if(this.sameRoundedBg(texture)) return
        this.removeRoundedBg()
        const w = useInitialPosition ? this.initialPosition.w : this.width
        const h = useInitialPosition ? this.initialPosition.h : this.height
        this.roundedBg = new RoundedBgView(w, h, this, texture, radius)
    }

    private sameRoundedBg(texture: PIXI.Texture): boolean {
        if(this.roundedBg == undefined) return false
        return this.roundedBg.isSameBg(texture)
    }

    removeRoundedBg() {
        if(this.roundedBg == undefined) return
        if(this.roundedBg.parent == undefined) return
        this.roundedBg.parent.removeChild(this.roundedBg)
    }

    removeBg() {
        if(this.bg.parent == undefined) return
        this.bg.parent.removeChild(this.bg)
    }

    private replaceOldBg(newBg: PIXI.Graphics) {
        if(this.bg != undefined && this.bg.parent != undefined) this.bg.parent.removeChild(this.bg)
        this.bg = newBg
    }

    makeRoundedBgInvisible() {
        this.drawRoundedBg()
        this.roundedBg.alpha = 0
    }
}
